/**
 * Support and Feedback where there is no sidebar.
 *
 * Support lives in the sidebar rail, above the avatar. A signed-in page that
 * renders no Sidebar — Terms and Privacy, the logs placeholder, a loading,
 * access-denied or error screen (exactly where someone needs to report a
 * problem) — would otherwise have no way to reach it, so this icon takes the
 * viewport's bottom inline-start corner there, and only there: it renders
 * nothing while a rail entry is mounted.
 */

import { useAuth } from '@/hooks/useAuth';
import { useLanguage } from '@/hooks/useLanguage';
import { openSupportPanel, useHasSupportRailEntry } from './supportWidget';
import { SupportIcon } from './SupportIcon';

export function SupportFallbackButton() {
  const { isAuthenticated, user } = useAuth();
  const { t } = useLanguage();
  const hasRailEntry = useHasSupportRailEntry();

  if (!isAuthenticated || hasRailEntry) return null;

  return (
    <button
      type="button"
      className="support-fallback-btn"
      onClick={() => openSupportPanel(user)}
      title={t('sidebar.supportAndFeedback')}
      aria-label={t('sidebar.supportAndFeedback')}
      data-testid="support-fallback-btn"
    >
      <SupportIcon />
    </button>
  );
}
